import React from 'react'
import styles from './AppointmentsDisabilitiesController.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { AppointmentStatus } from '../../utils/enums'

const TableHeader = ({ headers }) => {
	const { i18n } = useGlobal()

	return (
		<thead>
			<tr>
				{headers.map((header) => (
					<th>{i18n.translate(header)}</th>
				))}
			</tr>
		</thead>
	)
}

const TableRow = ({
	headers,
	row,
	isOrigin,
	isInChain,
	onRowClick,
	onEditAppointment,
}) => {
	const { i18n } = useGlobal()
	const className = isOrigin
		? styles['--row-selected-origin']
		: isInChain
		? styles['--row-selected']
		: ''
	const isExecuted = row.StateId === AppointmentStatus.Executed

	return (
		<tr
			className={className}
			onClick={() => onRowClick?.(String(row.Id))}
			style={{ cursor: 'pointer' }}
		>
			{headers.map((header) =>
				header === 'Id' ? (
					<td key={header}>
						<span className={styles['id-cell']}>
							{isExecuted ? (
								<button
									type='button'
									title={i18n`Edit this appointment's connection`}
									aria-label={i18n`Edit this appointment's connection`}
									className={
										styles['edit-appointment-button']
									}
									onClick={(e) => {
										e.stopPropagation()
										onEditAppointment?.(String(row.Id))
									}}
								>
									<Icon
										name='branch'
										width='16px'
										height='16px'
									/>
								</button>
							) : (
								<span
									className={
										styles['edit-appointment-spacer']
									}
								/>
							)}
							{row[header]}
						</span>
					</td>
				) : (
					<td key={header}>{row[header]}</td>
				)
			)}
		</tr>
	)
}

const TableBody = ({
	headers,
	data,
	selectedId,
	selectedPathIds,
	onRowClick,
	onEditAppointment,
}) => {
	return data.map((appointment) => {
		const rowId = String(appointment.Id)
		return (
			<TableRow
				key={appointment.Id}
				headers={headers}
				row={appointment}
				isOrigin={rowId === String(selectedId)}
				isInChain={selectedPathIds.includes(rowId)}
				onRowClick={onRowClick}
				onEditAppointment={onEditAppointment}
			/>
		)
	})
}

const AppointmentsTable = ({
	data,
	selectedId,
	selectedPathIds = [],
	onRowClick,
	onEditAppointment,
}) => {
	const headers = data?.length
		? Object.keys(data[0]).filter((header) => header !== 'StateId')
		: []

	return data?.length ? (
		<table>
			<TableHeader headers={headers} />
			<tbody>
				<TableBody
					headers={headers}
					data={data}
					selectedId={selectedId}
					selectedPathIds={selectedPathIds}
					onRowClick={onRowClick}
					onEditAppointment={onEditAppointment}
				/>
			</tbody>
		</table>
	) : null
}

export default AppointmentsTable
